/**
 * @generated SignedSource<<c41a47c132c7af9affa124c2a948186c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type spotlightTourContainer_jqlBuilderWithAi$data = {
  readonly isNaturalLanguageSpotlightTourEnabled: boolean | null | undefined;
  readonly " $fragmentType": "spotlightTourContainer_jqlBuilderWithAi";
};
export type spotlightTourContainer_jqlBuilderWithAi$key = {
  readonly " $data"?: spotlightTourContainer_jqlBuilderWithAi$data;
  readonly " $fragmentSpreads": FragmentRefs<"spotlightTourContainer_jqlBuilderWithAi">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "spotlightTourContainer_jqlBuilderWithAi",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isNaturalLanguageSpotlightTourEnabled"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "c677e86a45a387c3d35af97d3ab14b64";

export default node;
